export const INTERCOM_APP_ID = 'odnoznr4';
